export default __webpack_public_path__ + "static/media/soul-yellow-light.0d55366b.png";